import { autoinject } from "aurelia-dependency-injection";
import * as MepScenarioPlanning from "../../constants/mep/mep-scenario-planning.constants";
import { MepPortTrafficActualEmissionsResponse, MepShorePowerActualEmissionsRequest, MepShorePowerActualEmissionsResponse } from "../../models/mep/mep-scenario-planning.models";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";

@autoinject()
export class MepScenarioPlanningSerivce {
    constructor(private requestClient: RequestClientService) {
    }

    public getMepShorePowerActualEmissionsByPoi(request: MepShorePowerActualEmissionsRequest): Promise<MepShorePowerActualEmissionsResponse> {
        return this.requestClient.post<MepShorePowerActualEmissionsResponse>(`${MepScenarioPlanning.Urls.GetMepShorePowerActualEmissionsByPoi}`, {}, request);
    }

    public getMepPortTrafficActualEmissionsByVesselType(request: MepShorePowerActualEmissionsRequest): Promise<MepPortTrafficActualEmissionsResponse> {
        return this.requestClient.post<MepPortTrafficActualEmissionsResponse>(`${MepScenarioPlanning.Urls.GetMepPortTrafficActualEmissionsByVesselType}`, {}, request);
    }
}